import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#FFDC83" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6875 9.08505L8.65406 16.0712C7.69246 17.7367 5.61048 16.5347 6.57207 14.8692L10.6055 7.88302C9.07216 5.51721 10.3757 2.93883 13.0596 2.8845L12.3651 4.08745C11.0562 6.35447 13.8322 7.95717 15.141 5.69016L15.8355 4.48721C17.255 7.15733 15.5492 9.25705 12.6875 9.08503L12.6875 9.08505ZM8.86117 14.2167L8.27352 15.2345C7.92626 15.836 7.13977 15.3819 7.48702 14.7804L8.07467 13.7626C8.42193 13.1611 9.20842 13.6152 8.86117 14.2167Z"
      fill="#000"
    />
  </svg>
);

export default SvgComponent;